import { useDispatch, useSelector } from "react-redux";
import { initQa, qaStart } from "../../../../modules/reducers/chat/bot/qa";
import { chatbotApi } from "./../../api/bot/chatbotApi";
import { useEffect, useState } from "react";
import chatbotInitForNobrandApi from "../../../SelectBranch/api/chatbotInitForNobrandApi";
import { setChatbot } from "../../../../modules/reducers/chat/bot/initForNobrand";

const useChatbotQuery = () => {
  const dispatch = useDispatch();
  const channelId = useSelector((state) => state.checkArsStatus.channelId);
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");

  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const branchId = useSelector((state) => state.checkArsStatus.branchId);
  const NB_BranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );
  const messageList = useSelector((state) => state.qa.messageList);
  const channel_id = useSelector((state) => state.parseUrl.channelId);

  const temp_UserId = useSelector((state) => state.parseUrl.userId);
  const user_id = temp_UserId??"".replaceAll(" ", "+");

  const initForNobrandLoaded = useSelector(
    (state) => state.initForNobrand.data
  );
  const api = chatbotApi();
  const data = {
    action_type: "QUERY",
    user_id: userId,
    inflo_chnl_id: channelId,
    brand_id: brandId,
    branch_cd: branchId || NB_BranchId,
    message: '{"type":"GREET_RESPOND_NORMAL","message":""}',
  };

  const search = ({ message }) => {
    if (message.trim() !== "") {
      data.message = message;
      const userId = messageList && messageList[0]?.sender?.userId;
      if (userId === "erody" || userId === "landy") {
        dispatch(qaStart({ ...api, data }));
      }
    }
  };

  useEffect(() => {
    if (NB_BranchId) {
      const api = chatbotInitForNobrandApi();
      const data = {
        channelId: channel_id, // expired에서 받은 chnlId 의 값을 입력
        inflowType: "LND",
        chatBotType: NB_BranchId, //선택한 점포 id
        userId: user_id,
      };
      dispatch(setChatbot({ ...api, data }));
    } else if (brandId === "LD") {
      const api = chatbotInitForNobrandApi();
      const data = {
        channelId: channel_id, // expired에서 받은 chnlId 의 값을 입력
        inflowType: "LND",
        chatBotType: branchId, //랜더스 점포
        userId: user_id,
      };
      dispatch(setChatbot({ ...api, data }));
    } else {
      if (messageList?.length === 0) {
        dispatch(qaStart({ ...api, data }));
      }
    }
  }, []);

  useEffect(() => {
    if (initForNobrandLoaded) {
      if (messageList?.length === 0) {
        dispatch(qaStart({ ...api, data }));
      }
    }
  }, [initForNobrandLoaded]);

  return { search, messageList, userId };
};

export default useChatbotQuery;
